import { RowBetween, RowCenter, RowMiddle } from 'layout/Components/Row'
import styled from 'styled-components'
import { Icons } from 'svgs'
import Button from 'UIKit/Button'
import Skeleton from 'UIKit/Skeleton'
import TransText from 'UIKit/Text/TransText'
import { CardSection, CardTitle } from 'views/Tournament'

const LeaderBoardLoader = () => {
  return (
    <CardSection>
      <RowBetween mb="22px">
        <RowMiddle>
          <CardTitle marginRight="12px">LeaderBoard</CardTitle>
          <Skeleton />
        </RowMiddle>

        <StyledFullboardBtn>
          <RowCenter>
            <TransText
              fontSize="12px"
              fontWeight={400}
              lineHeight="normal"
              letterSpacing={-0.28}
              color="#7A7A7A"
              mr="3px"
            >
              Full Board
            </TransText>
            <Icons.ChevronRightIcon fill="#7A7A7A" width="10px" height="12px" />
          </RowCenter>
        </StyledFullboardBtn>
      </RowBetween>

      <Skeleton />
      <Skeleton my={'4px'} />
      <Skeleton my={'4px'} />
      <Skeleton />
    </CardSection>
  )
}

const StyledFullboardBtn = styled(Button)`
  padding: 0px;
  height: fit-content;
  background: none;
`

export default LeaderBoardLoader
